import { useState, useEffect } from "react";
import { toast } from "sonner";
import { adminApi, AdminHeader, EmptyState } from "@/lib/adminApi";

const Field = ({ label, value }) => value ? (
  <div><p className="text-[10px] uppercase tracking-wider text-[var(--text-secondary)]">{label}</p><p className="text-sm text-white">{value}</p></div>
) : null;

const AdminInquiries = () => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    adminApi("/admin/signups")
      .then((d) => setItems([...d.speaking_inquiries.entries].sort((a, b) => (b.created_at || "").localeCompare(a.created_at || ""))))
      .catch((e) => toast.error(e.message));
  }, []);
  if (!items) return <div className="text-[var(--text-secondary)]">Loading...</div>;

  return (
    <div>
      <AdminHeader title="Speaking Inquiries" subtitle={`${items.length} booking requests`} testId="inquiries-heading" />
      {items.length === 0 ? <EmptyState text="No inquiries yet" testId="inquiries-empty" /> : (
        <div className="space-y-4" data-testid="inquiries-list">
          {items.map((q) => (
            <div key={q.id} className="bg-[var(--bg-card)] border-glow rounded-xl p-6">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="text-lg font-semibold text-white">{q.name} <span className="text-[var(--text-secondary)] font-normal">· {q.organization}</span></h3>
                  <a href={`mailto:${q.email}`} className="text-sm text-[var(--accent-violet-light)]">{q.email}</a>
                </div>
                <span className="text-xs text-[var(--text-secondary)]">{q.created_at ? new Date(q.created_at).toLocaleDateString() : ""}</span>
              </div>
              <div className="grid sm:grid-cols-4 gap-4 mb-3">
                <Field label="Event type" value={q.event_type} />
                <Field label="Date" value={q.event_date} />
                <Field label="Audience" value={q.audience_size} />
                <Field label="Budget" value={q.budget} />
              </div>
              {q.message && <p className="text-sm text-[var(--text-secondary)] leading-relaxed">{q.message}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminInquiries;
